import React from 'react'
import Judul from './judul'
import './style.css'
import {Container} from 'react-bootstrap'

export default function jumbotron() {
    return (
        <Container>
            <div className="jumbotron-berberkah">
                <Judul judul="Pusat Jual Beli Produk Muslim Termurah" />
                <p>Di sini, Kamu bisa membeli berbagai produk halal unggulan dari produk UMKM lokal dengan harga dan kualitas terbaik.</p>
                <div className="gambar">
                    <img src="asset/berberkah/ssg.png" alt="ssg" />
                </div>
            </div>
       </Container>
    )
}
